module.exports = __webpack_public_path__ + "static/media/Healthcare_white.836fa577.svg";